var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-filter-config',{attrs:{"state":_vm.is,"loginRequired":true,"selfOnly":true,"hideButton":_vm.window.width < 400},on:{"expand":_vm.onExpandClick,"close":_vm.onCloseClick,"save":_vm.onSaveClick}},[_c('app-config-template-plays-usernames'),_c('app-config-template-sync-plays-incomplete'),_c('app-config-template-insights-hindex-expansions')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }